import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

export const ProductCard = ({ product, onAddToWishlist, isInWishlist }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(price);
  };

  return (
    <div className="product-card group" data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.id}`}>
        <div className="image-container aspect-[3/4] relative overflow-hidden">
          <img
            src={product.images?.[0] || 'https://via.placeholder.com/400x600'}
            alt={product.name}
            className="product-image w-full h-full object-cover"
          />
          {product.is_drop && (
            <div className="absolute top-3 left-3 bg-[#FF3B30] text-white text-xs uppercase tracking-widest px-3 py-1">
              Drop
            </div>
          )}
          {onAddToWishlist && (
            <button
              onClick={(e) => {
                e.preventDefault();
                onAddToWishlist(product.id);
              }}
              className={`absolute top-3 right-3 p-2 bg-black/50 backdrop-blur-sm transition-all ${
                isInWishlist ? 'text-[#FF3B30]' : 'text-white hover:text-[#FF3B30]'
              }`}
              data-testid={`wishlist-btn-${product.id}`}
            >
              <Heart size={18} fill={isInWishlist ? '#FF3B30' : 'none'} />
            </button>
          )}
        </div>
      </Link>
      <div className="p-4">
        <Link to={`/product/${product.id}`}>
          <h3 className="font-medium text-sm mb-1 group-hover:text-[#FF3B30] transition-colors line-clamp-1">
            {product.name}
          </h3>
        </Link>
        <p className="text-muted-foreground text-xs uppercase tracking-wider mb-2">
          {product.category}
        </p>
        <div className="flex items-center justify-between">
          <span className="font-medium">{formatPrice(product.price)}</span>
          {product.colors && product.colors.length > 0 && (
            <div className="flex space-x-1">
              {product.colors.slice(0, 3).map((color, idx) => (
                <span
                  key={idx}
                  className="w-3 h-3 border border-neutral-700"
                  style={{
                    backgroundColor: color.toLowerCase() === 'white' ? '#fff' :
                      color.toLowerCase() === 'black' ? '#000' :
                      color.toLowerCase() === 'cream' ? '#FFFDD0' :
                      color.toLowerCase() === 'olive' ? '#556B2F' :
                      color.toLowerCase() === 'sand' ? '#C2B280' :
                      color.toLowerCase() === 'charcoal' ? '#36454F' :
                      color.toLowerCase() === 'sage' ? '#9DC183' :
                      color.toLowerCase() === 'grey' || color.toLowerCase() === 'gray' ? '#808080' :
                      color.toLowerCase() === 'navy' ? '#000080' :
                      color.toLowerCase() === 'red' ? '#FF0000' :
                      color.toLowerCase() === 'dusty pink' ? '#D4A5A5' :
                      color.toLowerCase()
                  }}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
